module.exports = __webpack_public_path__ + "img/item_img.1463abdd.png";